import React from 'react';
import { dotStyle, flex } from '@fabric-ui/theme';
import { stringToColor } from '@fabric-ui/utils';
import { Box, useTheme } from '@mui/material';

interface AvAvatarProps {
  displayName?: string;
}

export const AvAvatar: React.FC<AvAvatarProps> = ({ displayName = 'Unknown' }) => {
  const theme = useTheme();
  return (
    <Box
      component="span"
      sx={{
        ...flex.center,
        backgroundColor: stringToColor(displayName, theme.palette.avatarColors),
        ...dotStyle(undefined, '100%' as any),
      }}>
      <Box
        sx={{
          fontWeight: 600,
          fontSize: 12,
          color: theme.palette.white.main,
          textTransform: 'uppercase',
        }}>
        {displayName[0]}
      </Box>
    </Box>
  );
};
